import { animate, state, style, transition, trigger } from '@angular/animations';

export class RotaryDialAnimations {
  public static main = trigger('main', [
    state(
      'show',
      style({
        transform: 'translate({{x}}px, {{y}}px)',
        opacity: 1,
      }),
      { params: { x: 0, y: 0, ox: 0, oy: 0 } },
    ),
    state(
      'hide',
      style({
        transform: 'translate({{ox}}px, {{oy}}px)',
        opacity: 0,
      }),
      { params: { x: 0, y: 0, ox: 0, oy: 0 } },
    ),
    transition('show => hide', [animate('0.2s ease-in-out')]),
    transition('hide => show', [animate('0.2s ease-in-out')]),
  ]);
}
